import { mxgraphInstance } from './mxgraphFactory';

/**
 * View
 */
export const mxCellEditor = mxgraphInstance.mxCellEditor;
export const mxCellOverlay = mxgraphInstance.mxCellOverlay;
export const mxCellRenderer = mxgraphInstance.mxCellRenderer;
export const mxCellState = mxgraphInstance.mxCellState;
export const mxCellStatePreview = mxgraphInstance.mxCellStatePreview;
export const mxConnectionConstraint = mxgraphInstance.mxConnectionConstraint;
export const mxEdgeStyle = mxgraphInstance.mxEdgeStyle;
export const mxGraph = mxgraphInstance.mxGraph;
export const mxGraphSelectionModel = mxgraphInstance.mxGraphSelectionModel;
export const mxGraphView = mxgraphInstance.mxGraphView;
export const mxLayoutManager = mxgraphInstance.mxLayoutManager;
export const mxMultiplicity = mxgraphInstance.mxMultiplicity;
export const mxOutline = mxgraphInstance.mxOutline;
export const mxPerimeter = mxgraphInstance.mxPerimeter;
export const mxPrintPreview = mxgraphInstance.mxPrintPreview;
export const mxStyleRegistry = mxgraphInstance.mxStyleRegistry;
export const mxStylesheet = mxgraphInstance.mxStylesheet;
export const mxSwimlaneManager = mxgraphInstance.mxSwimlaneManager;
export const mxTemporaryCellStates = mxgraphInstance.mxTemporaryCellStates;

// export const renderingHint = mxgraphInstance.renderingHint;

/**
 * mxGraphSelectionModel
 */
// export const mxSelectionChange = mxgraphInstance.mxSelectionChange;

/**
 * mxGraphView
 */
// export const mxCurrentRootChange = mxgraphInstance.mxCurrentRootChange;